import type { MegaMenuCategoryConfig } from "./mega-menu";
import { buildRoute, ROUTES } from "routes";
import { ACTIVE_SERVICE_CATEGORIES, ACTIVE_SERVICE_CATEGORY_KEYS } from "constants/categories";

export { ACTIVE_SERVICE_CATEGORY_KEYS };

export function buildServicesMenuCategories(formatMessage: (key: string) => string): MegaMenuCategoryConfig[] {
    return ACTIVE_SERVICE_CATEGORY_KEYS.map((key) => {
        const { Icon, palette, slug, subcategories } = ACTIVE_SERVICE_CATEGORIES[key];
        const categoryKey = key.toLowerCase();

        return {
            id: key,
            title: formatMessage(`category.${categoryKey}`),
            href: `${ROUTES.PROVIDERS}?filter_categories=${key}`,
            palette,
            Icon,
            items: subcategories.map((sub) => ({
                id: sub.key,
                label: formatMessage(`subcategory.${categoryKey}.${sub.key.toLowerCase()}.label`),
                href: buildRoute.servicesByCategory(slug, sub.slug),
            })),
        };
    });
}

export const SERVICES_MENU_PANEL = {
    viewAllHref: ROUTES.PROVIDERS,
    catalogKey: "menu.services_catalog",
    viewAllKey: "menu.services_view_all",
    ariaLabelKey: "menu.our_services",
} as const;
